<template>
    <b-modal
        :visible="value"
        scrollable
        no-fade
        ok-only
        ok-title="Asignar"
        title="Cotizacion/Venta v2"
        size="xl"
        body-class="position-static girlLookAtThatBody"
        hide-footer
        no-close-on-backdrop
        @close="exit()"
        @show="showed"
        @hide="hidded"

    >
        <div>
            <b-row>
                <b-col>
                    <b-breadcrumb>
                        <b-breadcrumb-item active>Reserva</b-breadcrumb-item>
                        <b-breadcrumb-item v-if="viewModel.id === -1" active><b>Cotización nueva reserva</b></b-breadcrumb-item>
                        <b-breadcrumb-item active v-else><b>#{{ viewModel.id }}</b></b-breadcrumb-item>
                    </b-breadcrumb>
                </b-col>
            </b-row>
            <b-tabs content-class="mt-3" fill v-model="tabIndex">
                <b-tab title="Traslado" active>
                    <!-- contenido de tralasdos -->
                    <!-- filtros para buscar transport services -->
                    <form>
                        <b-row>
                            <b-col sm="12" md="5">
                                <b-form-group label="Punto de venta">
                                    <multiselect
                                        placeholder="Seleccionar opcion"
                                        v-model="formModel.pointOfSaleId"
                                        :options="
                                            $root.auxVars.pointOfSalesOpts
                                        "
                                        label="text"
                                        track-by="value"
                                        :allow-empty="false"
                                        deselect-label="Debe seleccionar al menos una opcion"
                                        @input="getSettingPointOfSale"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col sm="12" md="3">
                                <b-form-group label="Tipo de viaje">
                                    <b-form-select
                                        :options="categoryRidesOpts"
                                        v-model="categoryRide"
                                    ></b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md>
                                <b-form-group label="Pickup">
                                    <vue-typeahead-bootstrap
                                        required
                                        v-model="pickup.search"
                                        class="input-fix typeahead"
                                        ref="pickupField"
                                        show-all-results
                                        :placeholder="'Buscar'"
                                        :serializer="(place) => place.name"
                                        :data="pickup.data"
                                        @keyup="searchPlace('pickup', pickup.search)"
                                        @hit="(selected) =>setPlace('pickup', selected)"
                                    >
                                        <template #suggestion="{ data, htmlText }">
                                            <md-icon icon="flight" v-if="data.isAirport"/>
                                            <md-icon icon="place" v-else />
                                            <span v-html="htmlText"></span><br />
											<small>{{data.address}}</small>
                                        </template>
                                        <template #prepend>
                                            <b-input-group-text>
                                                <b-spinner v-if="pickup.loading" small/>
                                                <span v-else>
                                                    <md-icon :icon="iconFrom" />
                                                </span>
                                            </b-input-group-text>
                                        </template>
                                    </vue-typeahead-bootstrap>
									<span class="text-danger" v-if="pickup.search.length<=3">El campo debe contener 4 o mas caracteres</span>
                                </b-form-group>
                            </b-col>
                            <b-col class="col-auto px-md-0 pt-md-4 py-2 mx-auto">
                                <b-form-checkbox
                                    v-model="a2bWayBoolean"
                                    name="check-button"
                                    button
                                    size="sm"
                                    button-variant="success"
                                    @change="swapPlaces()"
                                >
                                    <md-icon :icon="'swap_horiz'" />
                                </b-form-checkbox>

                            </b-col>

                            <b-col md>
                                <b-form-group label="dropoff">
                                    <vue-typeahead-bootstrap
                                        required
                                        v-model="dropoff.search"
                                        class="input-fix typeahead"
                                        ref="dropoffField"
                                        show-all-results
                                        :placeholder="'Buscar'"
                                        :serializer="(place) => place.name"
                                        :data="dropoff.data"
                                        @keyup="searchPlace('dropoff',dropoff.search)"
                                        @hit="(selected) =>setPlace('dropoff', selected)"
                                    >
                                        <template #suggestion="{ data, htmlText }">
                                            <md-icon
                                                icon="flight"
                                                v-if="data.isAirport"
                                            />
                                            <md-icon icon="place" v-else />
                                            <span v-html="htmlText"></span><br />
											<small>{{data.address}}</small>
                                        </template>
                                        <template #prepend>
                                            <b-input-group-text>
                                                <b-spinner
                                                    v-if="dropoff.loading"
                                                    small
                                                />
                                                <span v-else>
                                                    <md-icon :icon="iconTo" />
                                                </span>
                                            </b-input-group-text>
                                        </template>
                                    </vue-typeahead-bootstrap>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="1">
                                <b-form-group
                                    label="Roundtrip?"
                                    class="text-center">
                                    <b-form-checkbox
                                        v-model="formModel.roundTrip"
                                        name="check-button"
                                        switch>
									</b-form-checkbox>
                                </b-form-group>
                            </b-col>
                            <b-col md="3">
								<b-form-group label="Ida">
									<b-form-datepicker
										aria-required="true"
										v-model="formModel.serviceDate"
										required
										size=""
										class="mb-1"
										locale="es"
										reset-button
										close-button
										:date-format-options="{
											year: 'numeric',
											month: 'short',
											day: '2-digit',
											weekday: 'short',
										}"
									/>
									<vue-timepicker
										v-model="formModel.serviceTime"
										manual-input
										class="mb-1"
									></vue-timepicker>
								</b-form-group>
                            </b-col>
                            <b-col md="3">
                                <b-form-group  label="Regreso" :disabled="!formModel.roundTrip">
                                    <b-form-datepicker
										aria-required="true"
                                        v-model="formModel.returnServiceDate"
                                        locale="es"
                                        reset-button
                                        close-button
										class="mb-1"
                                        :date-format-options="{
                                            year: 'numeric',
                                            month: 'short',
                                            day: '2-digit',
                                            weekday: 'short',
                                        }"
                                    />
									<vue-timepicker
										v-model="formModel.returnServiceTime"
										manual-input
										class="mb-1"
									></vue-timepicker>
                                </b-form-group>
                            </b-col>

                            <b-col md="3">
                                <b-row>
                                    <b-form-group
                                        :label="'Adultos'"
                                        class="col-md-4">
                                        <b-form-select
                                            v-model="formModel.adults"
                                            :disabled="paxDisabled">
                                            <b-form-select-option
                                                v-for="(item, i) in 100"
                                                :value="i"
                                                :key="i"
                                                >{{ i }}</b-form-select-option>
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group
                                        :label="'Menores'"
                                        class="col-md-4">
                                        <b-form-select
                                            v-model="formModel.children"
                                            :disabled="paxDisabled">
                                            <b-form-select-option
                                                v-for="(item, i) in 100"
                                                :value="i"
                                                :key="i"
                                                >{{ i }}</b-form-select-option
                                            >
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group
                                        :label="'Infantes'"
                                        class="col-md-4">
                                        <b-form-select
                                            v-model="formModel.infants"
                                            :disabled="paxDisabled">
                                            <b-form-select-option
                                                v-for="(item, i) in 100"
                                                :value="i"
                                                :key="i">
												{{ i }}
											</b-form-select-option>
                                        </b-form-select>
                                    </b-form-group>
                                </b-row>
                            </b-col>
                            <b-col md="2" class="pt-md-4 py-2">
                                <div>
                                    <b-button
										v-if="Object.keys(rateSelected).length === 0"
                                        variant="primary"
                                        @click="searchPrices"
                                        :class="hasChangedSinceLastSearch? 'shake' : ''">
                                        <md-icon
                                            v-if="hasChangedSinceLastSearch"
                                            icon="refresh"
                                        />Buscar</b-button>
                                </div>
                            </b-col>
                        </b-row>
                    </form>

                    <div style="min-height: 25rem">
                        <!-- resultado de busqueda -->
						<hr class="mb-3">
                        <section v-if="!offer.show">
                            <b-row v-if="loading">
                                <b-col
                                    md="6"
                                    v-for="_j in [1, 2, 3, 4]"
                                    :key="_j">
                                    <b-card class="mb-2">
                                        <b-skeleton animation="throb" width="85%"></b-skeleton>
										<b-skeleton animation="throb" width="55%"></b-skeleton>
										<b-skeleton animation="throb" width="70%"></b-skeleton>
                                    </b-card>
                                </b-col>
                            </b-row>
                            <b-row v-else class="p-2">
                                <b-col
                                    md="6"
                                    v-for="(_service, _index) in services"
                                    :key="_index"
                                    class="mb-3 px-2">
                                    <CardService
                                        :currency="formModel.currency"
                                        :ticket="ticket"
                                        :shuttle="_service"
										:checked="_index==indexRateSelected"
										:showButtons="Object.keys(rateSelected).length === 0"
										:showButtonADDService="_index==indexRateSelected"
										@viewAdditionalServices="tabIndex=1; cargaTab()"
										@rateSelected="(rateSelected)=>{rateSelectedAction(rateSelected, _index)}"
										@rateSelectedOffer="showOfferForm(_service,_index)"
										@tracePromoSelected="showTracePromotion"
									/>
                                </b-col>
                            </b-row>
                        </section>
                        <!-- editar precio de ride -->
                        <section id="custom-price" v-if="offer.show">
                            <formOffer
                                :ticket="ticket"
                                :shuttle="offer.originalRate"
                                :currency="formModelSubmitted.currency"
                                :formModel="formModelSubmitted"
                                @rateSelectedOffer="applyOfferAction"
                            />
                            <div class="mt-2 d-flex w-100 justify-content-center">
                                <b-button
                                    variant="info"
                                    @click="() => (offer.show = false)"
                                    ><md-icon icon="chevron_left"></md-icon>
                                    Regresar a la lista</b-button
                                >
                            </div>
                        </section>
                    </div>

                </b-tab>
                <!-- si existe transport services seleccionados muestra los adtServices -->
                <b-tab
                    v-if="_newTrasnpServices.length > 0"
					@click="cargaTab()"
                    title="Servicios adicionales">
                    <!-- resultado de servicios adicionales -->
                    <AdditionalServices
						ref="refAdditionalServices"
						:arrayAdditionalServices=arrayAdditionalServices
						:currency="formModel.currency? formModel.currency:'usd'"/>
                </b-tab>

                <!-- Agregamos un tab adicional al final -->
                <template #tabs-end>
                    <div class="d-flex pb-1 pl-2">

						<div class="flex-grow-1 d-flex border rounded border-primary">
							<label class="u:bg-white-1 px-2 m-0 d-flex justify-content-center align-items-center">Moneda</label>
							<select class="border-none h-100"  v-model="formModel.currency" @change="selectedOtherCurrency">
								<option v-for="(item, index) in currenciesOpts" :key="index" :value="item.value">{{item.text}}</option>
							</select>
						</div>

                        <Cart
							:propViewModel="viewModel"
							:propRateSelected="rateSelected"
							:propRoundTrip="formModelSubmitted.roundTrip"
							@deleteTransportService="deleteTransportService()"
							@deleteAdditionalServices="deleteAdditionalServices()"
							@bookCart="bookCart"/>
                    </div>
                </template>
            </b-tabs>
        </div>

		<b-modal ref="modalPromotionTrace" size="lg">
			<TracePromotion :tracePromotion="tracePromotion"></TracePromotion>
		</b-modal>
    </b-modal>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import moment from "moment";
import api from "@/api.js";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import CardService from "./transport-services/CardService";
import formOffer from "./transport-services/FormOffer.vue";
import Multiselect from "vue-multiselect";
import debounce from "debounce";

import AdditionalServices from "@/components/sections/reservations/quoteV2/additional-services/index.vue";
import Cart from "@/components/sections/reservations/quoteV2/cart/index.vue";

import Utils from '@/plugins/Utils.js';
import TracePromotion from  '@/components/helpers/TracePromo.vue'
import vueTimepicker from "vue2-timepicker";
export default {
    components: {
        AdditionalServices,
        CardService,
        VueTypeaheadBootstrap,
        Multiselect,
        formOffer,
		Cart,
		TracePromotion,
		vueTimepicker
    },
    props: {
        value: Boolean,
        formTypeWork: {
            default: "newReservations", //newReservation - editReservation
            require: false,
        },
    },
    data() {
        const iconsConfigByCategory = {
            apto: { a2b: "flight", b2a: "place" },
            p2p: { a2b: "place", b2a: "place" },
        };

        const placeModelDefault = {
            address: "",
            airportIata: "",
            isAirport: false,
            latitude: "",
            longitude: "",
            name: "",
        };
        const formModelDefault = {
            lang: "es",
            pointOfSaleId: { value: 353, text: "Direct Sales" },
            currency: null,
            adults: 1,
            children: 0,
            infants: 0,
            roundTrip: false,
            pickup: { ...placeModelDefault },
            dropoff: { ...placeModelDefault },
            serviceDate: "",
			serviceTime: "00:00",
            returnServiceDate: "",
			returnServiceTime:"",
            tripType: "",
            searchType: "",
        };

        return {
			tabIndex:0,//indice del tabPrincipal

            formModel: { ...formModelDefault },
            formModelSubmitted: { ...formModelDefault },

            pickup: {
                search: "",
                data: [],
                loading: false,
            },
            dropoff: {
                search: "",
                data: [],
                loading: false,
            },
            services: [],

            categoryRide: "apto",
            a2bWayBoolean: true,
            iconsConfigByCategory: iconsConfigByCategory,

            currenciesList: [],
            loading: false,
            rateSelected: {},
			indexRateSelected:-1,
            offer: {
                show: false,
                applied: false,
                originalRate: {}, //rate selected original
                formData: {}, //el formulario con el nuevo precio
            },
            salesChannelIdPointOfSale: null,

			//variable que recupera servicios adiconales
			arrayAdditionalServices:[],
			//variable que guarda temporalmente el el modelo a tratarse
			viewModelCart:{
				id:null
			},

			confirmBookCart:false,

			//guarda la moneta temporal
			tempCurrency:'',
			tracePromotion:{},
        };
    },
    watch: {

    },
    mounted() {
        this.$root.auxVars.loadResourcesOpts({
            vm: this,
            resourceNames: ["pointOfSalesOpts"],
        });
        this.getSettingPointOfSale();
        this.showed();

    },
    computed: {
        ...mapState("reservation", ["viewModel", "quote"]),
		_newTrasnpServices(){
			return this.viewModel.transportServices.filter(item=>{
				return item.id==-1 || item.status == "active" || item.status == "pending";//??TS || item.status == "active"
			})
		},
        categoryRidesOpts() {
            return [
                { text: "Transporte de aeropuerto", value: "apto" },
                { text: "Punto a punto", value: "p2p" },
            ];
        },
        a2bWayCode() {
            return this.a2bWayBoolean ? "a2b" : "b2a";
        },
        a2bWayCodeInverted() {
            return !this.a2bWayBoolean ? "a2b" : "b2a";
        },
        iconFrom() {
            return this.iconsConfigByCategory[this.categoryRide][
                this.a2bWayCode
            ];
        },
        iconTo() {
            return this.iconsConfigByCategory[this.categoryRide][
                this.a2bWayCodeInverted
            ];
        },
        ticket() {
            //definimos si el filtro de busqueda es roundTrip o oneway
            return this.formModelSubmitted.roundTrip ? "roundtrip" : "oneway";
        },
        currenciesOpts() {
            let opts = [{ value: null, text: "Seleccione una opción" }];
            this.currenciesList.forEach((val) => {
                let item = { value: val, text: val };
                opts.push(item);
            });
            return opts;
        },
        paxDisabled() {
            return this.viewModel.id > 0;
        },
        hasChangedSinceLastSearch() {
            return (
                JSON.stringify(this.formModel) !==
                    JSON.stringify(this.formModelSubmitted) &&
                this.services.length > 0
            );
        },
		_getIata() {
			let iata = null;
			this.viewModel.transportServices.every((service) =>{
				if(service.pickup.isAirport == true){
					iata=service.pickup.airportIata;
					return false;
				}else if(service.dropoff.isAirport == true){
					iata=service.dropoff.airportIata;
					return false;
				}else{
					return true;
				}
			});
			return iata;
		}
    },
    methods: {
        ...mapMutations("reservation", [
            "SET_NEW_MODEL",
            "SET_RESET_MODEL",
            "ADD_TRANSPORT_SERVICE",
			"SET_TRANSPORT_SERVICE",
            "SET_UPDATE_TRANSPORT_SERVICE",
            "SET_UPDATE_QUOTE_PROPS",
            "DEL_TRANSPORT_SERVICE"
        ]),
		cargaTab() {
			if(this._getIata!=null){
				//obtenemos los additional services
				this.getAdditionalServices();

			}else{
				this.$root.showAlert("No existe codigo IATA para el servicio de transporte", { variant: "danger" });
			}
		},
        exit() {
            //retornamos false al valor v-model del componente
            this.$emit("input", false);
        },
        swapPlaces() {
            let _aux = {
                pickup: { ...this.formModel.dropoff },
                dropoff: { ...this.formModel.pickup },
            };
            Object.assign(this.formModel, _aux);
            this.pickup.search = this.formModel.pickup.name;
            this.dropoff.search = this.formModel.dropoff.name;
        },
        async setPlace(type, selected) {
            let infoSelectec = { ...selected };
            if (selected.ref !== "") {
                // busca los detalles del objeto
                infoSelectec = (
                    await api(this).get(`quote/places/${selected.ref}`)
                ).data;
                this[`${type}`].data = [{ ...infoSelectec }];
                this.formModel[`${type}`] = infoSelectec;
            } else {
                this[`${type}`].search = "";
                this[`${type}`].data = [];
                return;
            }
        },
        searchPrices() {
            if (this.validate()) {
                this.resetOfferFields();
                this.loading = true;
                this.services = [];

                this.formModel.tripType = this.formModel.roundTrip
                    ? "roundtrip"
                    : "oneway";
                if (this.categoryRide == "apto") {
                    this.formModel.searchType = this.a2bWayBoolean
                        ? "A2H"
                        : "H2A";
                } else {
                    this.formModel.searchType = "P2P";
                }

                this.formModelSubmitted = { ...this.formModel };

                api(this)
                    .get(`quote/prices`, { params: this.formModel })
                    .then((res) => {
                        if (Array.isArray(res.data)) {
                            this.services = res.data;
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        searchPlace: debounce(function (attrName, term) {
            if (term !== "") {
                this[`${attrName}`].data = [];
                this[`${attrName}`].loading = true;
                api(this)
                    .get(`quote/places/search`, { params: { term } })
                    .then((res) => {
                        this[`${attrName}`].data = res.data;
                        //this[`${attrName}Loading`] = false;
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                    .finally(() => {
                        this[`${attrName}`].loading = false;
                    });
            }
        }, 500),
        getSettingPointOfSale() {
            api(this)
                .get(`point-of-sales/${this.formModel.pointOfSaleId.value}`)
                .then((res) => {
                    this.currenciesList = res.data.settingVars.currencies;
                    this.formModel.currency = this.currenciesList[0] ?? null;
					this.tempCurrency=this.formModel.currency;
                    this.salesChannelIdPointOfSale = res.data.salesChannelId;
                    //this[`${attrName}Loading`] = false;
					//obtenemos los additional services
					this.getAdditionalServices();
                });
        },
        validate() {
            try {
                if (this.isEmpty(this.formModel.currency)) {
                    throw "Moneda es requerido";
                }
                if (this.isEmpty(this.formModel.pickup.ref)) {
                    throw "Pickup es requerido";
                }
                if (this.isEmpty(this.formModel.dropoff.ref)) {
                    throw "Dropoff es requerido";
                }

                if (this.isEmpty(this.categoryRide)) {
                    throw "tipo de servicio es requerido";
                }
                if (this.isEmpty(this.formModel.serviceDate)) {
                    throw "Fecha ida es requerido";
                }
                if (
                    this.formModel.roundTrip &&
                    this.isEmpty(this.formModel.returnServiceDate)
                ) {
                    throw "Fecha de regreso es requerido";
                }
                if (this.isEmpty(this.formModel.adults)) {
                    throw "Adultos es requerido";
                }
            } catch (err) {
                this.$root.showAlert(err, { variant: "danger" });
                return false;
            }
            return true;
        },
        isEmpty(val) {
            return val === null || val === undefined || val === "";
        },
        getTsForReservation() {
            //definimos si el viaje es de ida y vuelta(roundTrip)
            let qtyServices = this.formModelSubmitted.roundTrip ? 2 : 1;
            //-----------
            // Sacamos el id de los places
            //-----------
            let infoPickup = this.formModelSubmitted.pickup.ref.split("-");
            let pickupId = parseInt(infoPickup[1]);
            let pickupType = infoPickup[0];
            let infoDropoff = this.formModelSubmitted.dropoff.ref.split("-");
            let dropoffId = parseInt(infoDropoff[1]);
            let dropoffType = infoDropoff[0];
            //-----------
            //-----------
            // obtenemos todos los transport services
            let transportServices = [];
            for (let _a = 0; _a < qtyServices; _a++) {
                let ts = {};
                let pickupPlace = {
                    ...this.formModelSubmitted.pickup,
                    ...{ id: pickupId, type: pickupType },
                };
                let dropoffPlace = {
                    ...this.formModelSubmitted.dropoff,
                    ...{ id: dropoffId, type: dropoffType },
                };
                switch (_a) {
                    case 0: //ida
                        ts.pickup = { ...pickupPlace };
                        ts.dropoff = { ...dropoffPlace };
                        ts.pickupPlaceId = ts.pickup.id;
                        ts.dropoffPlaceId = ts.dropoff.id;
                        ts.flightDatetime =
                            this.formModelSubmitted.serviceDate + " 00:00:00";
                        ts.pickupDatetime =
                            this.formModelSubmitted.serviceDate + " 00:00:00";
                        break;
                    case 1: //regreso
                        ts.pickup = { ...dropoffPlace };
                        ts.dropoff = { ...pickupPlace };
                        ts.pickupPlaceId = ts.pickup.id;
                        ts.dropoffPlaceId = ts.dropoff.id;
                        ts.flightDatetime =
                            this.formModelSubmitted.returnServiceDate +
                            " 00:00:00";
                        ts.pickupDatetime =
                            this.formModelSubmitted.returnServiceDate +
                            " 00:00:00";
                        break;
                }
                ts.fromQuote = true;
                let totalOriginal = this.offer.applied
                    ? this.offer.originalRate[this.ticket]
                    : this.rateSelected[this.ticket];
                ts.quote = {
                    ratePlanId: this.rateSelected.ratePlanId,
                    bookingPriceTotal:
                        this.rateSelected[this.ticket] / qtyServices,
                    bookingPriceTotalOriginal: totalOriginal / qtyServices,
                    bookingCurrency: this.rateSelected.currency,
                    ticket: this.ticket,
                    specialRate: this.offer.applied,
                    specialRateData: this.offer.formData,
                };

                ts.ratePlanInfo = this.rateSelected.ratePlanInfo; // used by rateplans != sc
                ts.salesChannelId =
                    this.salesChannelIdPointOfSale != null
                        ? this.salesChannelIdPointOfSale
                        : this.rateSelected.salesChannelId;
                ts.serviceTypeId = this.rateSelected.serviceType.id;
                ts.ratePlanType = this.rateSelected.ratePlanType;
                ts.serviceTypeName = this.rateSelected.serviceType.name;
                ts.pointOfSaleId = this.formModelSubmitted.pointOfSaleId;
                ts.status = "pending";
                transportServices.push(ts);
            }

            if (this.viewModel.id === -1) {
                //es una reserva nueva
                if (this.formModelSubmitted.roundTrip) {
                    this.ADD_TRANSPORT_SERVICE();
                }
                transportServices.forEach((dataTs, _indexTs) => {
                    let payload = {
                        index: _indexTs,
                        data: dataTs,
                    };
                    this.SET_UPDATE_TRANSPORT_SERVICE(payload);
                });
            } else if (this.viewModel.id > 0) {
                //en que situacion se da?
				if (this.formModelSubmitted.roundTrip) {
                    this.ADD_TRANSPORT_SERVICE();
                }
                transportServices.forEach((dataTs, indexTS) => {
                    // this.ADD_TRANSPORT_SERVICE(); //??porque ese crear un nuevo transport-services
                    //obtenemos el total de transportservices seleccionados
                    let totalServices = this.viewModel.transportServices.length;
                    //generamos un index
                    let _indexTs = totalServices - (this.formModelSubmitted.roundTrip?2:1) + indexTS;
                    //actualizamos el canal de referencia con el sufijo incrementado
                    dataTs.salesChannelReference = this.viewModel.id + "-" + totalServices;
                    // dataTs.salesChannelId = this.viewModel.id+"-"+(totalServices);
                    let payload = {
                        index: _indexTs,
                        data: dataTs,
                    };
                    this.SET_UPDATE_TRANSPORT_SERVICE(payload);
                });
            }
            return transportServices;
        },
        rateSelectedAction(rateSelected, indexRateSelected) {

            // guardamos el rate seleccionado
            this.rateSelected = rateSelected;
			this.indexRateSelected=indexRateSelected;
            // ejecutamos el metodo que recuperar el ride
            this._processData();
        },
        _processData() {
            //la logica
            //-1 = nuevo modelo
            //es nuevo?
            if (this.viewModel.id === -1) {
                //resetea el modelo de reservas
                // this.SET_RESET_MODEL();//?? porque se resetea si en el ultimo paso volvemos a asignar la misma variable
                let aux = { ...this.viewModel };
                aux.adults = this.formModelSubmitted.adults;
                aux.children = this.formModelSubmitted.children;
                aux.infants = this.formModelSubmitted.infants;
                this.SET_NEW_MODEL(aux);
            }
            //crearmos un nuevo transportService para recuperar los datos de la siguiente funcion
            this.ADD_TRANSPORT_SERVICE();
            //recuperamos los transportServices con los detalles del formulario de reservacion
            this.getTsForReservation();
			// //generamos los nuevos idcart para los TS
			this.setIdCartTransportService();
			this.$root.showAlert("Se agrego un Servicio de transporte correctamente", { variant: "success" });

        },
		setIdCartTransportService(){
			//recuperamos los transportServices actuales
			let auxViewModel = JSON.parse(JSON.stringify(this.viewModel));
			// let auxTransportService=JSON.parse(JSON.stringify(this.viewModel.transportServices));
			auxViewModel.transportServices.forEach((itemTS, index)=>{
				//agregamos una propiedad llamada cardId para guardar la referencia entre ts y servicios adicionales
				//generamos el id
				let auxCartID="cart:"+this.viewModel.id+"-"+(index+1);
				//existe la propiedad creada?
				if("cartId" in itemTS){
					//reasignamos el id
					itemTS.cartId=auxCartID;
				}else{
					//creamos la propiedad cardId
					Object.assign(itemTS, {cartId:auxCartID})
				}
				// //generamos un idViewModelReference para cada transportService
				// Object.assign(item, {idViewModelReference: this.viewModel.id+"-"+(index+1)});
			});



			let cartData={
				total:0,
				bookingCurrency:""
			}
		// 		this.dateField= moment(new Date()).format("YYYY-MM-DD");
		// this.timeField= moment(new Date()).format("HH:mm");
			let paymentInfo={
				date:moment(new Date()).format("YYYY-MM-DD"),
				time:moment(new Date()).format("HH:mm")
			}
			Object.assign(auxViewModel, {cartData: cartData});
			Object.assign(auxViewModel, {paymentInfo: paymentInfo});
			this.SET_NEW_MODEL(auxViewModel);
			// this.SET_TRANSPORT_SERVICE(auxTransportService);
		},
        showOfferForm(rateSelected, indexRateSelected) {
            this.offer.show = true;
            this.offer.originalRate = { ...rateSelected };
			//guardamos la posicion del rate seleccionado
			this.indexRateSelected = indexRateSelected;
        },
		showTracePromotion(event) {
			this.tracePromotion = event
			this.$refs["modalPromotionTrace"].show();
        },
        applyOfferAction({
            originalRate,
            customRate,
            formData: offerFormData,
        }) {
            //reseteamos el formulario de oferta
            this.resetOfferFields();
            //recuperamos la oferta aplicada
            this.offer.applied = true; //bandera para saber que aplicó precio especial
            this.offer.formData = { ...offerFormData };
            this.offer.originalRate = { ...originalRate };
            this.rateSelected = { ...customRate };
            // ejecutamos el metodo que recuperar el transport service y ride
            // this.rateSelectedAction(customRate, originaIndexRate);
			this._processData();
        },
        showed() {

			//el id de la reserva pasada es distinta?
            if (this.viewModelCart.id == this.viewModel.id) {

				//SOLO PARA EDITAR UN RESERVA YA CREADA
				//recuperamos el viewModel con el carrito
				if(this.viewModel.id>0 || this.formTypeWork == "newForm"){
					this.SET_NEW_MODEL(this.viewModelCart);
				}
                this.formModel.adults = this.viewModel.adults;
                this.formModel.children = this.viewModel.children;
                this.formModel.infants = this.viewModel.infants;

				//anteriromente se preciono la confirmacion del carrito?
				if(this.confirmBookCart==true){
					this.viewModelOriginal = JSON.parse(JSON.stringify(this.viewModel));
					//reseteamos la bandera de confirmacion de compra de carrito
					this.confirmBookCart=false;
				}


            }else{
				// this.$nextTick(()=>{
				this.viewModelOriginal = JSON.parse(JSON.stringify({...this.viewModel}));

				if (this.viewModel.id > 0 || this.formTypeWork == "newForm") {
					//recuperamos el modelo
					this.reset();
					this.selectedOtherCurrency();
					if(this.formTypeWork == "newForm"){
						// eliminaos todos los transport service
						this.DEL_TRANSPORT_SERVICE(0);
					}
					this.viewModelCart=JSON.parse(JSON.stringify(this.viewModel));
				}else{
					this.reset();
					this.selectedOtherCurrency();
					// nuevo modelo
					this.SET_RESET_MODEL();
					// eliminaos todos los transport service
					this.DEL_TRANSPORT_SERVICE(0);
				}
				//generamos los nuevos idcart para los TS
				this.setIdCartTransportService();
				// });
			}

			if (process.env.NODE_ENV === "development") {
                //llenamos loca campos de pickup y dropoff para pruebas mas rapidas
                this.formModel.pickup = {
                    ref: "scplace-3665",
                    name: "Terminal 4 Aeropuerto Internacional de Cancun",
                    address: "Benito Juárez, Quintana Roo, Mexico",
                    isAirport: true,
                    latitude: "21.04676300",
                    longitude: "-86.87979330",
                    airportIata: "CUN",
                };
                this.pickup.search = this.formModel.pickup.name;
                this.formModel.dropoff = {
                    ref: "scplace-812",
                    name: "Hard Rock Hotel Cancun",
                    address:
                        "Blvd. Kukulcan 14.5, Zona Hotelera, 77500 Cancún, Q.R., Mexico",
                    isAirport: false,
                    latitude: "21.08970250",
                    longitude: "-86.77088810",
                    airportIata: null,
                };
                this.dropoff.search = this.formModel.dropoff.name;
                this.formModel.serviceDate = moment().format("YYYY-MM-DD");
            }
        },
        hidded() {
			//guardamos el id de la actual cotizacion de reserva
			this.viewModelCart = JSON.parse(JSON.stringify(this.viewModel));

			//SOLO PARA EDITAR UN RESERVA YA CREADA
			//volvemos a la normalidad el viewModel original
			if((this.viewModel.id>0 || this.formTypeWork == "newForm") && this.confirmBookCart == false){
				//recuperamos el viewModel con el carrito
				this.SET_NEW_MODEL(this.viewModelOriginal);
			}



			//ocualtamos el dialogo de cotizacion
            this.SET_UPDATE_QUOTE_PROPS({ showForm: false });
        },
        reset() {
            Object.assign(this.$data, this.$options.data.apply(this));
            this.getSettingPointOfSale();
        },
        resetOfferFields() {
            this.offer.show = false; //ocultamos modulo
            this.offer.applied = false; //bandera para saber que aplicó precio especial
            this.offer.originalRate = {}; //reset
            this.offer.formData = {}; //reset
            return true;
        },
		getAdditionalServices() {
			api(this)
				.get(
					"/quote/additional-services",
					{
						params: {
							lang: "es",
							iata:this._getIata,
							currency:this.formModel.currency
						}
					}
				)
				.then((res) => {
					//recuperamos solo los registros de typo other(additional services)
					this.arrayAdditionalServices = res.data.map(item=>
					{
						//agregamos una variable auxiliar para guardar la cantidad que se desea agregar al carrito
						item.prices.forEach(itemPrice => {
							itemPrice.quantity = 0
						})
						item.selected = false
						//agregamos una variable auxiliar para detectar si fue seleccionado
						return item
					});

				})
				.catch(this.$root.handleRequestError)
				.finally(() => {

				});
		},
		deleteTransportService(){
			this.$bvModal.msgBoxConfirm('¿Realmente desea eliminar el transport services actual? Tambien se eliminaran todos los servicios adicionales del carrito', {
				title: 'Eliminar',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'Si, continuar',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if(value){
					this.rateSelected = {};
					this.indexRateSelected = -1;
					let auxViewModel = JSON.parse(JSON.stringify(this.viewModel));
					auxViewModel.transportServices=auxViewModel.transportServices.filter((item)=>{
						// filtramos solo los id antiguos, eliminamos los nueos
						return item.id != -1;
					});
					//eliminamos los additional services
					this.$refs.refAdditionalServices.changeStatusAdditionalServices();
					// creamos un axuliar para amancenar el viewModel para poder iterar y que no sufra cambios en cada eliminacion
					auxViewModel.additionalServices=auxViewModel.additionalServices.filter((item)=>{
						// filtramos solo los id antiguos, eliminamos los nueos
						return item.id != -1;
					});
					this.SET_NEW_MODEL(auxViewModel);
				}
			});
		},
		deleteAdditionalServices(){
			this.$bvModal.msgBoxConfirm('Realmente desea eliminar todos los servicios adicionales', {
				title: 'Eliminar',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'Si, continuar',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if(value){
					this.$refs.refAdditionalServices.changeStatusAdditionalServices();
					// creamos un axuliar para amancenar el viewModel para poder iterar y que no sufra cambios en cada eliminacion
					let auxViewModel = JSON.parse(JSON.stringify(this.viewModel));
					auxViewModel.additionalServices=auxViewModel.additionalServices.filter((item)=>{
						// filtramos solo los id antiguos, eliminamos los nuevos
						return item.id != -1;
					});
					this.SET_NEW_MODEL(auxViewModel);
				}
			});
		},
		deleteAdditionalService(position){
			this.$bvModal.msgBoxConfirm('Realmente desea eliminar el servicio adicional', {
				title: 'Eliminar',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'Si, continuar',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if(value){
					let indexAS=null;
					this.viewModel.additionalServices.find((itemAS, index) => {
						indexAS=index;
						return Utils.sameObjects(itemAS, position);
					});

					if (indexAS!=null) {
						this.viewModel.additionalServices.splice(indexAS, 1);
						this.SET_NEW_MODEL(this.viewModel);
						this.$refs.refAdditionalServices.checkAddtionalServices();
					}


				}
			});
		},
		selectedOtherCurrency(){
			this.clearAllQuote();
		},
		clearAllQuote(){
			//guardamos la moneda de forma axuliar
			this.tempCurrency = this.formModel.currency;
			this.getAdditionalServices();
			let auxViewModel = JSON.parse(JSON.stringify(this.viewModel));
			//eliminamos los transporte services nuevos
			this.rateSelected = {};
			this.indexRateSelected = -1;
			if(this.viewModel.transportServices.length<=0){
				return;
			}
			// eliminamos los transportServices nuevos
			auxViewModel.transportServices=auxViewModel.transportServices.filter((item)=>{
				// filtramos solo los id antiguos, eliminamos los nuevos
				return item.id != -1;
			});
			this.SET_NEW_MODEL(auxViewModel);

			//eliminamos los additionalServices nuevos
			if(this.viewModel.additionalServices.length<=0){
				return;
			}
			auxViewModel.additionalServices=auxViewModel.additionalServices.filter((item)=>{
				// filtramos solo los id antiguos, eliminamos los nuevos
				return item.id != -1;
			});
			this.SET_NEW_MODEL(auxViewModel);
		},
		bookCart({date, time, cost}){
			this.confirmBookCart=true;
			//si la forma de trabajo es nuevo entonce retornanmos la bandera para la referencias
			// if(this.viewModel.id == -1){
				this.$emit('changeFormTypeWork', 'newFormLocationReferences');
			// }
			let auxViewModel = JSON.parse(JSON.stringify(this.viewModel));
			auxViewModel.cartData.total=cost;
			auxViewModel.paymentInfo.date=date;
			auxViewModel.paymentInfo.time=time;

			this.SET_NEW_MODEL(auxViewModel);
			if(this.viewModel.id == -1){
				//abrimos el modal de reservacion mediante emit
				this.$root.$emit(
					"bv::show::modal",
					"modal-reservations",
					event.target
				);
			}
			//cierra el modal retornando al mismo v-model=value del dialogo
			this.$emit("input",false);
		}
    },
};
</script>
<style scoped>
.border-none{
	border: none;
	outline: none;
}
.girlLookAtThatBody{
    overflow-y:inherit !important;
}
/* Animation property */
.shake {
    animation: wiggle 2s linear infinite;
}
/* Keyframes */
@keyframes wiggle {
    0%,
    7% {
        transform: rotateZ(0);
    }
    15% {
        transform: rotateZ(-15deg);
    }
    20% {
        transform: rotateZ(10deg);
    }
    25% {
        transform: rotateZ(-10deg);
    }
    30% {
        transform: rotateZ(6deg);
    }
    35% {
        transform: rotateZ(-4deg);
    }
    40%,
    100% {
        transform: rotateZ(0);
    }
}
</style>
